<template>
  <v-col class="containerMinHeightinner pa-0 mx-0 mb-0 mt-7">
    <loader v-if="contentLoading" />
    <v-row class="rightDashboardContainer mx-auto my-5">
      <v-col>
        <!-- Header of template contains action buttons like download, mark as spam etc.. -->
        <EmailTemplateArchivesHeader
          :openInModal="openInModal"
          :emitRecipientList="emitRecipientList"
          :archiveIdVal="archiveIdVal"
          :hideBulk="hideBulk"
          :archives="archives"
          :typeEmail="typeEmail"
          :attachmentList="attachmentList"
          :dataTestId="dataTestId"
          :canViewEmailBody="hasPermission"
        />
        <!-- Email details like To:- From:- Date:- etc -->
        <EmailTemplateArchivesDetail
          :emailId="emailId"
          :subject="subject"
          :openInModal="openInModal"
          :showActionBtnSent="showActionBtnSent"
          :fromEmail="fromEmail"
          :recipientsList="recipientsList"
          :ccEmail="ccEmail"
          :bccsEmail="bccsEmail"
          :date="date"
          :showImageLink="showImageLink"
          :dataTestId="dataTestId"
          @confirmationToEnable="confirmationToEnable"
        />
        <!-- <v-row class="mt-4"></v-row> -->
        <v-row class="mb-10 mt-2" no-gutters>
          <v-col class="my-12" align="center" v-if="!hasPermission">
            <div class="noPermissionContent">
             <i>{{ $message.NO_CONTENT_VIEW_PERMISSION }}</i>
            </div>
          </v-col>
          <v-col class="pa-0" v-else>
            <iframe
              id="emailContent"
              height="100%"
              width="100%"
              data-test-id="email-content-frame"
            ></iframe>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <x-dialog
      v-if="!openInModal"
      :dialogState="confirmDialogueVar"
      :dialogTitle="dialogTitle"
      :dialogText="dialogText"
      @toggleModal="cancelConfirmFunction"
      :confirmDialog="true"
      :dataTestId="`${dataTestId}__show-images-confirmation-modal`"
      :actions="{
        show: true,
        secondaryButtonFunction: cancelConfirmFunction,
        primaryButtonFunction: confirmSuccessFunction,
        primaryButtonShow: true,
        secondaryButtonText: cancelText,
        primaryButtonText: successText
      }"
    ></x-dialog>
  </v-col>
</template>

<script>
import EventBus from '@/EventBus';
import EmailTemplateArchivesDetail from '@/components/ArchiveSearch/EmailTemplateArchivesDetail';
import EmailTemplateArchivesHeader from '@/components/ArchiveSearch/EmailTemplateArchivesHeader';
import SearchService from '@/services/SearchService';
import ProjectService from '@/services/ProjectService';
import { mapState } from 'vuex';
export default {
  components: {
    EmailTemplateArchivesDetail,
    EmailTemplateArchivesHeader
  },
  data() {
    return {
      backTo: '',
      confirmDialogueVar: false,
      dialog: false,
      tosVisibility: false,
      recipientsList: '',
      fromEmail: '',
      ccEmail: '',
      subject: '',
      bccsEmail: '',
      date: '',
      emailBody: '',
      originalEmailBody: '',
      emailId: this.$route.params.archiveId || this.archiveId,
      spamReport: '',
      deliveryData: '',
      showImageLink: true,
      dialogTitle: 'Please Confirm',
      dialogText: '',
      cancelText: 'Cancel',
      successText: '',
      userId: '',
      loadTemplate: false,
      attachmentList: '',
      emaildetail: '',
      showActionBtnInbox: false,
      showActionBtnSpam: false,
      showActionBtnSent: false,
      archiveIdVal: [],
      hideBulk: true,
      dialogueList: [],
      emitRecipientList: [],
      contentLoading: false,
      archives: [],
      dataTestId: 'email-archive-details',
    };
  },
  props: { openInModal: Boolean, archiveId: String, type: String },
  computed: {
    ...mapState(['typeEmail']),
    hasPermission() {
      const isOrgEmail = this.type === 'email-org';
      return isOrgEmail
        ? this.isOwnOrgSelected()
          ? this.$can('view', 'organisation_email_body')
          : this.$can('view', 'child_organisation_email_body')
        : true;
    },
  },
  created() {
    this.userId = localStorage.getItem('userId');
  },
  mounted() {
    this.getEmailDetailTemplate(this.emailId, this.userId);
    EventBus.$on('HYPERLINK_CLICKED', data => {
      this.dialogText = data.dialogText;
      this.successText = data.successText;
      this.confirmDialogueVar = true;
    });
  },
  methods: {
    confirmSuccessFunction() {
      this.confirmDialogueVar = false;
      if (this.showImageLink !== true) {
        this.disableLinkClick();
        this.contentLoading = false;
        this.confirmDialogueVar = false;
        return;
      }
    },
    disableLinkClick() {
      document.getElementById(
        'emailContent'
      ).contentWindow.document.body.innerHTML = this.originalEmailBody;
      this.$nextTick(() => {
        // disable link click
        const content = document.getElementById('emailContent');
        let innerDoc =
          content.contentDocument || content.contentWindow.document;
        if (innerDoc) {
          innerDoc.querySelectorAll('a').forEach(el => {
            el.onclick = function(event) {
              let href = el.getAttribute('href');
              if (href) {
                window.open(href, '_blank');
              }
              event.preventDefault();
              event.stopPropagation();
              return false;
            };
          });
        }
      });
    },
    async getEmailDetailTemplate(emailId, userId) {
      if(this.hasPermission) {
        try {
        this.contentLoading = true;
        let archiveDetails = await SearchService.archiveDetails(
          emailId,
          userId
        );
        let tempRecord = archiveDetails.data.body[0];
        if (tempRecord.tos && tempRecord.tos.length > 0) {
          this.tosVisibility = true;
          this.recipientsList = this.getEmailList(tempRecord.tos);
        } else {
          this.recipientsList = '-';
          this.tosVisibility = false;
        }
        this.archiveIdVal.push(this.emailId);
        this.attachmentList = tempRecord.attachmentNames;
        this.spamReport = tempRecord.spamReport;
        this.deliveryData = tempRecord.deliveryReports;
        this.fromEmail = tempRecord.from;
        this.ccEmail = tempRecord.ccs;
        if (tempRecord.tos !== null && tempRecord.tos !== '') {
          this.emitRecipientList = this.emitRecipientList.concat(
            tempRecord.tos
          );
        }
        if (tempRecord.ccs !== null && tempRecord.ccs !== '') {
          this.emitRecipientList = this.emitRecipientList.concat(
            tempRecord.ccs
          );
        }
        if (this.typeEmail === 'sent') {
          if (tempRecord.bccs !== null && tempRecord.bccs !== '') {
            this.emitRecipientList = this.emitRecipientList.concat(
              tempRecord.bccs
            );
          }
        }
        if (tempRecord.bccs !== null) {
          this.bccsEmail = tempRecord.bccs;
        } else {
          this.bccsEmail = '';
        }
        this.subject = tempRecord.subject;
        this.date = this.getFormatedDateAsPerTimeAndDate(tempRecord.sentDate);
        this.originalEmailBody = this.sanitize(tempRecord.body);
        this.emailBody = this.sanitize(tempRecord.body);
        this.emailBody = this.openInModal
          ? this.originalEmailBody
          : this.customiseLink(this.emailBody);

        let emailContent = document.getElementById('emailContent');
        if (emailContent) {
          emailContent.contentDocument.body.innerHTML = this.emailBody;
        }

        this.$nextTick(() => {
          let content = document.getElementById('emailContent');

          let innerDoc =
            content.contentDocument || content.contentWindow.document;
          if (innerDoc) {
            innerDoc.querySelectorAll('a').forEach(el => {
              el.onclick = function(event) {
                const data = {
                  dialogText:
                    'Links in this email have been removed for safety. If you want to enable links, please click Show Images and Links',
                  cancelText: 'Cancel',
                  successText: 'Ok',
                  componentVar: 'true'
                };
                EventBus.$emit('HYPERLINK_CLICKED', data);
                event.preventDefault();
                event.stopPropagation();
                return false;
              };
            });
          }
        });
        if (this.openInModal) {
          this.disableLinkClick();
        }
        this.contentLoading = false;
        this.confirmDialogueVar = false;
      } catch (err) {
        this.contentLoading = false;
        this.snackbar('error', err);
      }
      }
    },
    async addToSaved() {
      try {
        await ProjectService.addArchives(this.$route.params.projectId, {
          archives: [this.emailId],
          archiveType: this.$enums.archiveType.EMAIL
        });
        this.snackbar('success', this.$message.ITEMS_SAVED);
        EventBus.$emit('REFRESH_COLLABORATORS', true);
        // this.
      } catch (err) {
        this.snackbar('error', this.$message.ERROR);
      }
    },

    customiseLink(str) {
      let temp = str;
      let replaceUrl = 'href="javascript:void(0)"  class="hyper-link"';
      let replaceSrc =
        '$2"https://via.placeholder.com/300x200.png?text=Xift+security"$5';
      let regexUrl = /href=(["'])(.*?)(["'])/g;
      var regexSrc = /((<img[^>]+src=)(['"](.*?)['"])([^>]*>))/g;
      temp = temp.replaceAll(regexUrl, replaceUrl);
      temp = temp.replaceAll(regexSrc, replaceSrc);

      return temp;
    },
    confirmationToEnable() {
      this.showImageLink = false;
      this.dialogText =
        'Are you sure you want to enable images and links? If you trust the source of this email press OK to enable images and links, otherwise click Cancel.';
      this.successText = 'Ok';
      this.confirmDialogueVar = true;
    },
    cancelConfirmFunction() {
      this.showImageLink = true;
      this.confirmDialogueVar = false;
    }
  },
  // eslint-disable-next-line
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.backTo = from.fullPath;
    });
  },
  beforeDestroy() {
    EventBus.$off('HYPERLINK_CLICKED');
  }
};
</script>

<style scoped>
#emailContent {
  border: 1px solid #eeeeee;
  padding: 10px;
  min-height: 800px;
}
</style>
